import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const TransporterUserProfileInfoComponent = ({ onBasicInnerFormChange,onInnerFormChange, selectedTransporters }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="FirstName"
              name="FirstName"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.FirstName',
                  selectedTransporters?.UserProfile
                )
              }}
              type="text"
              value={selectedTransporters?.UserProfile?.FirstName}
          />
       <InputContainer
              label="Last Name"
              name="LastName"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.LastName',
                  selectedTransporters?.UserProfile
                )
              }}
              type="text"
              value={selectedTransporters?.UserProfile?.LastName}
          />
      <InputContainer
              label="PersonTitle"
              name="PersonTitle"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.PersonTitle',
                  selectedTransporters?.UserProfile
                )
              }}
              type="text"
              value={selectedTransporters?.UserProfile?.Email}
          />
    <InputContainer
              label="ProfilePicture Url"
              name="ProfilePictureUrl"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.ProfilePictureUrl',
                  selectedTransporters?.UserProfile
                )
              }}
              type="text"
              value={selectedTransporters?.UserProfile?.ProfilePictureUrl}
          />
    </div>
 }
 expandedPanel="basicInfo"
 headerTitle="Basic Info"
/>
<AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="DeliveryHubEnabled"
              name="IsDeliveryHubEnabled"
              onValueChange={(event: any) => {
                onBasicInnerFormChange(
                  event,
                  'IsDeliveryHubEnabled'
                )
              }}
              type="checkbox"
              value={selectedTransporters?.IsDeliveryHubEnabled}
          />
    
    </div>
 }
 expandedPanel="DeliveryHubEnabled Info"
 headerTitle="DeliveryHubEnabled Info"
/>
</>
)
export default TransporterUserProfileInfoComponent;
